jQuery(document).ready(function($) {
	// JS for the drop down select in sub menus for mobile (Like Resources, News, etc.)

	// Hide the All menu item on Resources from the select on mobile
	$('.m-menu-subpages--resource .m-menu-subpages__dropdown li > a').filter(function () {
	    return $(this).text() == 'All';
	}).parent('li').addClass('is-hidden-mobile');

	//On load, Shows the current item as the selected option on the Select.
	$('.m-menu-subpages__dropdown li.current-menu-item > a').each( function() {
		//If is on a Resource Pages
		if( $(this).parents('.m-menu-subpages--resource').length ) {
			if( $(this).text() != 'All') {
				// If has a parent add it to the selelection
				var selectText = $(this).closest('.current-menu-parent:not(.current-menu-item)').children('a').text();

				if( selectText.length ) {
					$('.m-menu-subpages__select-content').html(selectText + ': <br> - ' + $(this).text());
				} else {
					$('.m-menu-subpages__select-content').text($(this).text());
				}
			}
		} else {
			// If is on another page.
			$('.m-menu-subpages__select-content').text($(this).text());
		}
	});

	// If the user clicks on an item that's already selected, it will close the menu.
	$('.m-menu-subpages__dropdown li.current-menu-item > a').click(function(e) {
		e.preventDefault();
		menuSubToggle();
	});
	

	$('.m-menu-subpages__select').click(function() {
		menuSubToggle();
	});

	function menuSubToggle() {
		$('.m-menu-subpages__ul-first').toggleClass('is-visible');
	}
});
